<template>
  <div class="content-group">
    <div v-for="(groupItem, key) in field.items" :key="key">
      <configField
        :id="id"
        :category="category"
        v-if="groupItem.type === 'config'"
        :field="getFieldData(groupItem.id)"
        :value="getConfigValue(groupItem.id)"
        :parentField="parentField"
        hideLabel
        hideTooltip
      />
      <div v-if="groupItem.type === 'content'" v-html="groupItem.content" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import configField from "@/components/config-field";

import getFieldData from "@/util/getFieldData";

export default {
  name: "ContentGroup",
  components: { configField },
  props: {
    category: {
      type: String,
    },
    field: {
      type: Object,
    },
    parentField: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  computed: {
    fieldList() {
      const fieldData =
        this.configTemplate && this.configTemplate[this.category];
      return fieldData && fieldData.AvailableFieldList;
    },
    ...mapGetters({
      mergedConfig: "getMergedConfig",
      configTemplate: "getConfigTemplate",
    }),
  },
  methods: {
    getConfigValue(id) {
      return (
        this.mergedConfig[this.id] &&
        this.mergedConfig[this.id][this.category] &&
        this.mergedConfig[this.id][this.category][id]
      );
    },
    getFieldData(id) {
      return getFieldData(this.fieldList, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $qvo-spacing-8;
}
</style>